module.exports = __webpack_public_path__ + "img/logo-demo.bb6f48d8.png";